import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function PracticeHeatmap({ data }) {
  if (!data || data?.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Practice Frequency Heatmap</h3>
        <div className="flex items-center justify-center h-64 text-gray-500">
          No practice frequency data available
        </div>
      </div>
    );
  }

  // Format date and sort by date
  const formattedData = data?.map(item => ({
      ...item,
      displayDate: new Date(item.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    }))?.sort((a, b) => new Date(a.date) - new Date(b.date))?.slice(-30); // Show last 30 days

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Practice Frequency Heatmap</h3>
        <div className="text-sm text-gray-600">Last 30 days</div>
      </div>
      
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={formattedData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
          <XAxis 
            dataKey="displayDate" 
            stroke="#6B7280"
            style={{ fontSize: '12px' }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis 
            stroke="#6B7280"
            style={{ fontSize: '12px' }}
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#FFF', 
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              padding: '8px 12px'
            }}
            formatter={(value, name) => {
              if (name === 'totalAttempts') return [`${value} attempts`, 'Practice Sessions'];
              if (name === 'uniqueUsers') return [`${value} students`, 'Active Students'];
              return value;
            }}
          />
          <Legend 
            wrapperStyle={{ fontSize: '12px' }}
          />
          <Bar 
            dataKey="totalAttempts" 
            fill="#8B5CF6" 
            name="Practice Sessions"
            radius={[8, 8, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}